/**
 * @voltxampere/schema — Migration types
 *
 * Per SPECS §1.8. A Migration is a tiny unit that moves data from one
 * schema version to the next. Migrations are pure functions — they take
 * the previous shape, return the next shape — with an optional
 * post-condition validator so the registry can catch a broken migrator
 * before it poisons the next step in the chain.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
/**
 * Thrown when no migration path exists between two versions, a migrator
 * itself throws, or a migrator's optional `validate` post-condition
 * rejects the output.
 */
export class MigrationError extends Error {
    name = "MigrationError";
    from;
    to;
    cause;
    constructor(message, from, to, cause) {
        super(message);
        this.from = from;
        this.to = to;
        this.cause = cause;
    }
}
//# sourceMappingURL=types.js.map